<p-table [value]="assignedTiers">
    <ng-template pTemplate="header">
        <tr>
            <th>Module</th>
            <th>Channel</th>
            <th>Type</th>
            <th>Tier</th>
            <th>Action</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product>
        <tr>
            <td>{{product.moduleName}}</td>
            <td>{{product.channel}}</td>
            <td>{{product.type?.name}}</td>
            <td>
                <span *ngFor="let s of product.preferredPriceTier; let i = index;">
                    {{s.priceTier?.name}}<span
                        *ngIf="product.preferredPriceTier?.length > 1 && i !== product.preferredPriceTier?.length-1">,</span>
                </span>
            </td>
            <td>
                <span class="btnBars p-mr-0" (click)="eidtAssignPriceTier(product)" pTooltip="Edit"
                    tooltipPosition="top">
                    <i class="pi pi-pencil"></i>
                </span>
                <span class="btnBars p-mr-0" (click)="viewAccounts(product.type,product.channelId)"
                    pTooltip="View" tooltipPosition="top">
                    <i class="pi pi-microsoft"></i>
                </span>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-dialog header="Assign Price Discount" [(visible)]="displayAssignPriceTier" [modal]="true" [responsive]="true"
    [style]="{width: '60vw'}" (onHide)="assignForm.reset();">
    <form [formGroup]="assignForm">
        <div class="card">
            <div class="p-grid">
                <div class="p-col-12 p-md-6">
                    <label>Module<span style="color:red;">*</span></label>
                    <p-dropdown [options]="allModules" optionLabel="name" placeholder="Select Module" appendTo="body"
                        (onChange)="loadConfigurations(assignForm.controls['moduleId'].value)" formControlName="moduleId"
                        [disabled]="!isAdd"></p-dropdown>
                </div>
                <div class="p-col-12 p-md-6">
                    <label>Channel<span style="color:red;">*</span></label>
                    <p-dropdown [options]="allChannels" optionLabel="name" placeholder="Select Channel" appendTo="body"
                     formControlName="channelId" [disabled]="!isAdd">
                    </p-dropdown>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-12 p-md-6">
                    <label>Discount Type<span style="color:red;">*</span></label>
                    <p-dropdown [options]="types" optionLabel="name" appendTo="body" [disabled]="!isAdd"
                        placeholder="Select Product Discount Type" (onChange)="loadTiers(assignForm.controls['typeId'].value)" formControlName="typeId"></p-dropdown>
                </div>
                <div class="p-col-12 p-md-6" *ngIf="assignForm.controls['typeId'].value?.name==discountQtyType">
                    <label>Price Tier<span style="color:red;">*</span></label>
                    <p-dropdown [options]="discountTypesTiers" optionLabel="name" appendTo="body" placeholder="Select Tier"
                     formControlName="preferredPriceTier">
                    </p-dropdown>
                </div>
                <div class="p-col-12 p-md-6"  *ngIf="assignForm.controls['typeId'].value?.name==discountGroupType">
                    <label>Price Tier<span style="color:red;">*</span></label>
                    <p-multiSelect [options]="discountTypesTiers" formControlName="preferredPriceTier" optionLabel="name" 
                    defaultLabel="Select Preferred" appendTo="body"></p-multiSelect>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-12">
                    <label>Option</label>
                    <div *ngFor="let opt of options" class="p-field-checkbox p-mb-0">
                        <p-radioButton [name]="ruleApplyTypeId" [value]="opt.id" formControlName="ruleApplyTypeId" inputId="option{{i}}"></p-radioButton>
                        <label for="option{{i}}">{{opt.name}}</label>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <p-footer>
        <button type="button" pButton (click)="displayAssignPriceTier=false" label="Cancel"
            class="p-button-secondary"></button>
        <button type="button" pButton label="Save" [disabled]="!assignForm.valid || isDisabled" (click)="save(assignForm.value)"></button>
    </p-footer>
</p-dialog>

<!-- For Accounts -->
<p-dialog [(visible)]="displayAccountTB" [modal]="true" [responsive]="true" [style]="{width: '80vw'}"
    [closable]="false">
    <div class="card">
        <p-table #dt [value]="accountsData" [paginator]="true" [totalRecords]="totalRecords" [lazy]="true"
            [rows]="pageSize" [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            (onPage)="getAccountsData($event)" [first]=first>
            <ng-template pTemplate="caption">
                <div class="p-d-flex p-jc-between">
                    <div style="width: 30%;">
                        <input pInputText type="text" (ngModelChange)="changed($event)"
                            [(ngModel)]="searchValue" placeholder="Search..." />
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th>Account Name</th>
                    <th>Street</th>
                    <th>City</th>
                    <th>State</th>
                    <th>Discount Type</th>
                    <th>Price Tier</th>
                    <th class="action" style="width: 2rem;">
                        <span class="btnBars p-mr-0">
                            <i class="pi pi-pencil" (click)="isEdit = !isEdit"></i>
                        </span>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-account let-rowIndex="rowIndex">
                <tr>
                    <td>{{account.name}}</td>
                    <td>{{account.street}}</td>
                    <td>{{account.city}}</td>
                    <td>{{account.state}}</td>
                    <td>{{account.priceTierTypeName}}</td>
                    <ng-container>
                        <td *ngIf="!isEdit && account.priceTierTypeName==discountQtyType">
                           {{account.preferredTier?.name}}
                        </td>
                        <td *ngIf="!isEdit && account.priceTierTypeName==discountGroupType">
                            <ng-container *ngFor="let s of account.preferredTier; let i = index;">
                                <span>{{s.name}}</span>
                                <span
                                    *ngIf="account.preferredTier?.length > 1 && i !== account.preferredTier?.length-1">,</span>
                            </ng-container>
                        </td>
                        <td *ngIf="isEdit && account.priceTierTypeName==discountGroupType" class="action">
                            <p-multiSelect [options]="discountTypesTiers" [(ngModel)]="account.preferredTier"
                                optionLabel="name" placeholder="Select Default" appendTo="body"
                                (onChange)="onChangeAccountAssignRule(account)"></p-multiSelect>
                        </td>
                        <td *ngIf="isEdit && account.priceTierTypeName==discountQtyType" class="action">
                            <p-dropdown [options]="discountTypesTiers" optionLabel="name" appendTo="body" placeholder="Select Tier"
                             [(ngModel)]="account.preferredTier" (onChange)="onChangeAccountAssignRule(account)">
                            </p-dropdown>
                        </td>
                    </ng-container>
                    <td class="action">
                        <p-checkbox [binary]="true" [(ngModel)]="account.isChecked" disabled></p-checkbox>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <p-footer>
        <button type="button" pButton (click)="cancelDialog()" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton label="Save" [disabled]="selectedAccounts?.length==0 || isDisabled" (click)="assignBulk()"></button>
    </p-footer>
</p-dialog>